module.exports = __webpack_public_path__ + "img/454.fcb3876c.png";